import React, { useEffect, useState } from "react";
import { matchPath, useLocation, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Users,
  ShoppingBag,
  Settings,
  LogOut,
  Menu,
  X,
  Download,
  Sliders,
  MessageSquare,
  Star,
  Image,
  List,
  FileText,
  StickyNote,
  Edit3,
  FileQuestionIcon,
} from "lucide-react";
import useAuthStore from "../store/authStore";
import QSet from "../pages/QSet";
import { FaTasks } from "react-icons/fa";

const menuItems = {
  webber: [
    // { icon: <LayoutDashboard className="w-5 h-5" />, label: 'Websites', path: '/websites' },
    // { icon: <Users className="w-5 h-5" />, label: 'Web Pages', path: '/web-pages' },
    // { icon: <ShoppingBag className="w-5 h-5" />, label: 'Course Programs', path: '/course-programs' },
    // { icon: <Menu className="w-5 h-5" />, label: 'Menus', path: '/menus' },
    // { icon: <Settings className="w-5 h-5" />, label: 'News & Notices', path: '/news-notices' },
    // { icon: <Download className="w-5 h-5" />, label: 'Downloads', path: '/downloads' },
    // { icon: <Sliders className="w-5 h-5" />, label: 'Sliders', path: '/sliders' },
    // { icon: <MessageSquare className="w-5 h-5" />, label: 'Popups', path: '/popups' },
    // { icon: <Star className="w-5 h-5" />, label: 'Testimonials', path: '/testimonials' },
    // { icon: <Image className="w-5 h-5" />, label: 'Gallery', path: '/gallery' },
    // { icon: <List className="w-5 h-5" />, label: 'Content Lists', path: '/content-lists' },
    // { icon: <FileText className="w-5 h-5" />, label: 'Forms', path: '/forms' },
    // { icon: <StickyNote className="w-5 h-5" />, label: 'Free Notes', path: '/free-notes' },
    {
      icon: <Edit3 className="w-5 h-5" />,
      label: "Quill Editor",
      path: "/quill",
    },
  ],
  qbank: [
    // { icon: <LayoutDashboard className="w-5 h-5" />, label: 'Websites', path: '/websites' },
    // { icon: <Users className="w-5 h-5" />, label: 'Web Pages', path: '/web-pages' },
    // { icon: <ShoppingBag className="w-5 h-5" />, label: 'Course Programs', path: '/course-programs' },
    // { icon: <Menu className="w-5 h-5" />, label: 'Menus', path: '/menus' },
    // { icon: <Settings className="w-5 h-5" />, label: 'News & Notices', path: '/news-notices' },
    // { icon: <Download className="w-5 h-5" />, label: 'Downloads', path: '/downloads' },
    // { icon: <Sliders className="w-5 h-5" />, label: 'Sliders', path: '/sliders' },
    // { icon: <MessageSquare className="w-5 h-5" />, label: 'Popups', path: '/popups' },
    // { icon: <Star className="w-5 h-5" />, label: 'Testimonials', path: '/testimonials' },
    // { icon: <Image className="w-5 h-5" />, label: 'Gallery', path: '/gallery' },
    // { icon: <List className="w-5 h-5" />, label: 'Content Lists', path: '/content-lists' },
    // { icon: <FileText className="w-5 h-5" />, label: 'Forms', path: '/forms' },
    // { icon: <StickyNote className="w-5 h-5" />, label: 'Free Notes', path: '/free-notes' },
    // { icon: <Edit3 className="w-5 h-5" />, label: 'Quill Editor', path: '/quill' },
    {
      icon: <FileQuestionIcon className="w-5 h-5" />,
      label: "Question Set",
      path: "/tools/qSet",
    },
    {
      icon: <FileQuestionIcon className="w-5 h-5" />,
      label: "Questions",
      path: "/tools/qset/questions",
    },
    {
      icon: <FaTasks className="w-5 h-5" />,
      label: "Tasks",
      path: "/tools/task",
    },
  ],
};

const SideMenu = ({ isOpen, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useAuthStore();
  const [index, setIndex] = useState("webber");

  useEffect(() => {
    if (
      matchPath("/tools", location.pathname) ||
      matchPath("/tools/*", location.pathname)
    ) {
      //if(matchPath("/tools/QSet", location.pathname)|| matchPath("/tools/QSet/*", location.pathname)){
      setIndex("qbank");
    } else setIndex("webber");
  }, [location]);

  // Handle menu item click: navigate and close on mobile
  const handleMenuItemClick = (path) => {
    navigate(path);
    if (window.innerWidth < 1024) {
      onClose();
    }
  };

  return (
    <div className="print:hidden">
      {/* Overlay for mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-20 lg:hidden"
          onClick={onClose}
        />
      )}

      <aside
        className={`fixed top-0 left-0 h-screen bg-white shadow-lg z-30 transition-all duration-300 transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } lg:translate-x-0 lg:w-64`}
      >
        <div className="flex flex-col h-full">
          {/* Logo and close button */}
          <div className="flex items-center justify-between p-4 border-b">
            <h1 className="text-xl font-bold text-blue-600">Admin Panel</h1>
            <button
              onClick={onClose}
              className="lg:hidden text-gray-500 hover:text-gray-700"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Menu items */}
          <nav className="flex-1 overflow-y-auto py-4">
            <ul className="space-y-1 px-2">
              {menuItems[`${index}`].map((item) => (
                <li key={item.path}>
                  <button
                    type="button"
                    onClick={() => handleMenuItemClick(item.path)}
                    className={`w-full text-left flex items-center px-4 py-3 rounded-lg transition-colors ${
                      location.pathname === item.path
                        ? "bg-blue-50 text-blue-600 font-medium"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                  >
                    <span className="mr-3">{item.icon}</span>
                    <span>{item.label}</span>
                  </button>
                </li>
              ))}
            </ul>
          </nav>

          {/* Logout button */}
          <div className="p-4 border-t">
            <button
              onClick={logout}
              className="flex items-center w-full px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors"
            >
              <LogOut className="w-5 h-5 mr-3" />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </aside>
    </div>
  );
};

export default SideMenu;
